import { render, staticRenderFns } from "./myinfo.vue?vue&type=template&id=8a359a02&"
import script from "./myinfo.vue?vue&type=script&lang=js&"
export * from "./myinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports